import { isEmpty } from 'lodash';

import {
  BotDataManagerType,
  HomeDataManagerType,
  PlazaOrgDataKey,
  PromotionOrgDataKey,
} from '@/const/promotion';
import { ISpace } from '@/interface';
import {
  Bot,
  IPlazaItemInput,
  IPlazaItemOutput,
  IPromotionItemInput,
  IPromotionItemOutput,
  ItemManage,
  Story,
} from '@/interface/promotion';
import { formStyle } from '@/pages/promotion/info/custom-form/custom-index/list/form-config/common';

export const enum OrgDataType {
  input = 'input',
  output = 'output',
}

/**
 * 数据处理 input提交数据，output请求返回数据
 * @param type
 * @param values
 * @returns
 */
export const orgItemData = (
  type: OrgDataType,
  values: IPromotionItemInput | IPromotionItemOutput,
) => {
  if (type === OrgDataType.input) {
    let postData: IPromotionItemOutput = {};
    const { stories, bots, name, managerType, space, topNum, bgImage } = (values as IPromotionItemInput) || {};
    const { story = [], others = [] } = stories || {};
    const newStories = story?.map((s) => {
      const temp = others?.find(o => o.id === s.id);
      return {
        story: s,
        ...temp,
      };
    });
    const newBots = bots?.bots?.map((b) => {
      const temp = (bots?.others || [])?.find(o => o.id === b.id);
      return {
        bot: b,
        ...temp,
      };
    }) || [];

    const newSpace = ((space as { opt?: ISpace })?.opt
      ? (space as { opt?: ISpace })?.opt
      : space) || {};
    const itemData: ItemManage = {
      name,
      stories: newStories,
      bots: newBots,
      space: newSpace as ISpace,
      topNum,
      bgImage,
    };
    const style = formStyle?.[
      managerType || HomeDataManagerType.HOMEDATAMANAGERTYPE_DEFAULT
    ];
    postData = {
      ...values,
      style,
    };
    const dataKey = managerType ? PromotionOrgDataKey[managerType] : '';
    if (dataKey) {
      if (managerType === HomeDataManagerType.HOMEDATAMANAGERTYPE_RECOMMEND) {
        // 单个对象
        postData = {
          ...values,
          [dataKey]: itemData?.stories?.[0] || {},
        };
      } else if (managerType === HomeDataManagerType.HOMEDATAMANAGERTYPE_MULTI_COLLECTION) {
      } else if (managerType === HomeDataManagerType.HOMEDATAMANAGERTYPE_OFFICIALGROUP) {
      } else {
        postData = {
          ...values,
          [dataKey]: itemData,
        };
      }
    }
    const deleteKeys = ['stories', 'bots', 'space', 'topNum', 'bgImage'];
    deleteKeys.forEach((key) => {
      delete postData?.[key as keyof IPromotionItemOutput];
    });
    return postData;
  }
  if (type === OrgDataType.output) {
    let postData: IPromotionItemInput = {};
    const inputValues = (values as IPromotionItemOutput) || {};
    const { managerType, materialMap } = inputValues;
    postData = {
      ...values,
      materialMap,
    };
    const dataKey = managerType ? PromotionOrgDataKey[managerType] : '';
    let itemData: ItemManage = {};
    if (dataKey) {
      itemData = (inputValues?.[dataKey as keyof IPromotionItemOutput] as ItemManage)
        || {};
      let story: Story['story'] = [];
      let others: Story['others'] = [];
      let botOthers: Bot['others'] = [];
      if (managerType === HomeDataManagerType.HOMEDATAMANAGERTYPE_RECOMMEND) {
        // 单个对象
        const { story, ...others } = itemData;
        const othersData = others as Story['others'];
        postData = {
          ...postData,
          stories: {
            story: story ? [{ ...story }] : [],
            others: othersData ? [{ ...othersData, id: story?.id }] : [],
          },
        };
      } else {
        const storyData = itemData?.stories?.map((e) => {
          const { story, ...others } = e;
          return {
            story,
            others: { ...others, id: story?.id || '' },
          };
        }) || [];
        const botData = itemData?.bots?.map((e) => {
          const { bot, ...botOthers } = e;
          return {
            bot,
            others: { ...botOthers, id: bot?.id || '' },
          };
        }) || [];
        story = (storyData
          .map(e => e.story)
          .filter(e => !isEmpty(e) && e !== undefined)
          || []) as unknown as Story['story'];
        others = storyData
          .map(e => e.others)
          .filter(e => !isEmpty(e) && e !== undefined) || [];
        const bots = (botData
          .map(e => e.bot)
          .filter(e => !isEmpty(e) && e !== undefined)
          || []) as unknown as Bot['bots'];
        botOthers = botData
          .map(e => e.others)
          .filter(e => !isEmpty(e) && e !== undefined) || [];
        postData = {
          ...postData,
          name: itemData?.name,
          space: itemData?.space,
          bgImage: itemData?.bgImage,
          bots: {
            bots,
            others: botOthers,
          },
          topNum: itemData?.topNum,
          stories: {
            story,
            others,
          },
        };
      }
    }
    return postData;
  }
  return {};
};

export const orgBotData = (
  type: OrgDataType,
  values: IPlazaItemInput | IPlazaItemOutput,
) => {
  if (type === OrgDataType.input) {
    let postData: IPlazaItemOutput = {};
    const { stories, bots, name, intro, managerType, space, topNum, bgImage } = (values as IPlazaItemInput) || {};
    const { story = [], others = [] } = stories || {};
    const newStories = story?.map((s) => {
      const temp = others?.find(o => o.id === s.id);
      return {
        story: s,
        ...temp,
      };
    });
    const newBots = bots?.bots?.map((b) => {
      const temp = (bots?.others || [])?.find(o => o.id === b.id);
      return {
        bot: b,
        ...temp,
      };
    }) || [];

    const newSpace = ((space as { opt?: ISpace })?.opt
      ? (space as { opt?: ISpace })?.opt
      : space) || {};
    const itemData: ItemManage = {
      name,
      stories: newStories,
      bots: newBots,
      space: newSpace as ISpace,
      topNum,
      bgImage,
      intro,
    };
    const style = formStyle?.[managerType || BotDataManagerType.BOTDATAMANAGERTYPE_DEFAULT];
    postData = {
      ...values,
      style,
    };
    const dataKey = managerType ? PlazaOrgDataKey[managerType] : '';
    if (dataKey) {
      postData = {
        ...values,
        [dataKey]: itemData,
      };
    }
    const deleteKeys = ['stories', 'bots', 'space', 'topNum', 'bgImage'];
    deleteKeys.forEach((key) => {
      delete postData?.[key as keyof IPlazaItemOutput];
    });
    return postData;
  }
  if (type === OrgDataType.output) {
    let postData: IPlazaItemInput = {};
    const inputValues = (values as IPlazaItemOutput) || {};
    const { managerType, materialMap } = inputValues;
    postData = {
      ...values,
      materialMap,
    };
    const dataKey = managerType ? PlazaOrgDataKey[managerType] : '';
    let itemData: ItemManage = {};
    if (dataKey) {
      itemData = (inputValues?.[dataKey as keyof IPlazaItemOutput] as ItemManage) || {};
      let story: Story['story'] = [];
      let others: Story['others'] = [];
      let botOthers: Bot['others'] = [];

      const storyData = itemData?.stories?.map((e) => {
        const { story, ...others } = e;
        return {
          story,
          others: { ...others, id: story?.id || '' },
        };
      }) || [];
      const botData = itemData?.bots?.map((e) => {
        const { bot, ...botOthers } = e;
        return {
          bot,
          others: { ...botOthers, id: bot?.id || '' },
        };
      }) || [];
      story = (storyData
        .map(e => e.story)
        .filter(e => !isEmpty(e) && e !== undefined)
        || []) as unknown as Story['story'];
      others = storyData
        .map(e => e.others)
        .filter(e => !isEmpty(e) && e !== undefined) || [];
      const bots = (botData
        .map(e => e.bot)
        .filter(e => !isEmpty(e) && e !== undefined)
        || []) as unknown as Bot['bots'];
      botOthers = botData
        .map(e => e.others)
        .filter(e => !isEmpty(e) && e !== undefined) || [];
      postData = {
        ...postData,
        name: itemData?.name,
        intro: itemData?.intro,
        space: itemData?.space,
        bgImage: itemData?.bgImage,
        bots: {
          bots,
          others: botOthers,
        },
        topNum: itemData?.topNum,
        stories: {
          story,
          others,
        },
      };
    }
    return postData;
  }
  return {};
};
